import { FEEDBACK_SURVEY_ID, feedbackCooldownRemaining } from '../../core/feedback';

/** Only a completion timestamp is stored; survey answers stay with the SDK. */
export function createFeedbackCooldown(userId: string) {
  const key = `osa:feedback:${FEEDBACK_SURVEY_ID}:${encodeURIComponent(userId)}:completed`;
  let completedAt: number | null = null;
  return {
    key,
    complete() {
      completedAt = Date.now();
      try { window.localStorage.setItem(key, String(completedAt)); } catch { /* Still hide for this page visit. */ }
    },
    remaining() {
      const now = Date.now();
      let remaining = feedbackCooldownRemaining(completedAt, now);
      try { remaining = Math.max(remaining, feedbackCooldownRemaining(Number(window.localStorage.getItem(key)), now)); } catch { /* Storage may be unavailable. */ }
      return remaining;
    },
  };
}
